
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoCNRTVDtGrid extends Serenity.EntityGrid<PoCNRTVDtRow, any> {
        protected getColumnsKey() { return PoCNRTVDtColumns.columnsKey; }
        protected getDialogType() { return PoCNRTVDtDialog; }
        protected getIdProperty() { return PoCNRTVDtRow.idProperty; }
        protected getInsertPermission() { return PoCNRTVDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoCNRTVDtRow.localTextPrefix; }
        protected getService() { return PoCNRTVDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}